import { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { useIsMobile } from '@/hooks/use-mobile';

interface MobileFormWrapperProps {
  children: ReactNode;
  className?: string;
}

export function MobileFormWrapper({ children, className }: MobileFormWrapperProps) {
  const isMobile = useIsMobile();
  
  return (
    <div className={cn(
      isMobile && [
        "[&_input]:h-12",           // Taller inputs
        "[&_textarea]:min-h-[120px]", // Taller textareas
        "[&_select]:h-12",          // Taller selects
        "[&_.grid]:grid-cols-1",    // Single column
        "[&_button]:min-h-[44px]",  // Touch-friendly buttons
        "[&_label]:text-base",      // Larger labels
      ],
      className
    )}>
      {children}
    </div>
  );
}
